import { filter, mergeMap, Observable, Subscription, withLatestFrom } from "rxjs";
import { Action } from "@reduxjs/toolkit";
import {
  uploadFile,
  fileUploadSuccess,
  fileUploadError,
  updateFileProgress,
  stopUpload,
  fileUploadStop
} from "../slices";
import { uploadFileToFirebase } from "../../services";
import { selectSiteId } from "../selectors";

export const uploadFileEpic = (
  action$: Observable<Action>,
  state$: Observable<any>
) => {
  return action$.pipe(
    filter(uploadFile.match),
    withLatestFrom(state$),
    mergeMap(([action, state]) => {
      const { fileName, file } = action.payload;
      const siteId = selectSiteId(state);

      return new Observable<Action>((observer) => {
        if (!siteId) {
          observer.next(fileUploadError(fileName));
          observer.complete();
          return;
        }

        const { uploadTask, result } = uploadFileToFirebase(
          file,
          `sites/${siteId}/original`,
          (progressData) => {
            observer.next(updateFileProgress({ 
              fileName, 
              progress: progressData.progress 
            }));
          }
        );

        let cancelled = false;
        let stopSubscription: Subscription | undefined;

        if (uploadTask) {
          stopSubscription = action$
            .pipe(
              filter(stopUpload.match),
            )
            .subscribe(() => {
              cancelled = true;
              uploadTask.cancel();
            });
        } else {
          observer.next(fileUploadError(fileName));
          observer.complete();
          return;
        }

        result
          .then((uploadResult) => {
            if (uploadResult.success) {
              observer.next(fileUploadSuccess(fileName));
            } else if (uploadResult.cancelled || cancelled) {
              observer.next(fileUploadStop(fileName));
            } else {
              observer.next(fileUploadError(fileName));
            }
          })
          .catch(() => {
            if (!cancelled) {
              observer.next(fileUploadError(fileName));
            }
          })
          .finally(() => {
            stopSubscription?.unsubscribe();
            observer.complete();
          });

        return () => {
          stopSubscription?.unsubscribe();
          if (!cancelled) {
            uploadTask.cancel();
            cancelled = true;
          }
        };
      });
    })
  );
};
